import gql from 'graphql-tag';

import embeddedDokkioTagFragment from './embeddedDokkioTagFragment';
import dokkioObjectDokkioTagFragment from './dokkioObjectDokkioTagFragment';
import taskFragment from './taskFragment';

export const dokkioThreadFragment = gql`
  fragment dokkioThreadFragment on DokkioThread {
    dokkioClass
    id
    accountID
    remoteID
    dokkioTags {
      ...embeddedDokkioTagFragment
    }
    dokkioObjectDokkioTags {
      ...dokkioObjectDokkioTagFragment
    }
    dokkioTagIDs
    tasks {
      ...taskFragment
    }
  }
  ${dokkioObjectDokkioTagFragment}
  ${embeddedDokkioTagFragment}
  ${taskFragment}
`;
export default dokkioThreadFragment;
